/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-17
 */
import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import override from "src/dectorators/override";
import {SnConfigDOI} from "./api/snConfigApi";
import SnConfigService from "./service/snConfigService";
import './snConfig.less';


@Component({name: 'sn-config'})
export default class SnConfig extends BasicSearchPage<SnConfigService, SnConfigDOI.RowDataI, SnConfigDOI.QueryRowDataParamsI> {

    @override
    renderHead(h) {
        return <div></div>
    }
    
	@override
	loadService () {
		this.service = new SnConfigService(this)
	}
}